import {
    createContext,
    useContext
} from 'react';
import { SizeType } from '../types';

interface AvatarContextType {
    size: SizeType;
    nameValue: string;
}

export const AvatarContext = createContext<AvatarContextType>({} as AvatarContextType);

export const useAvatarContext = () => {
    const context = useContext(AvatarContext);
    return context;
};
